import { createContext } from 'react';

export const ProductContext = createContext({
  products: [],
  totalProducts: 0,
  fetchAllProducts: () => {},
});
